/**
 * Display label for the notification workflow's document-type chip (LF-6151).
 *
 * These are *type labels*, not status — so per the LF-6148 recipe they stay a
 * structural `Badge` and carry no semantic colour. The three entries below used
 * to be a red / purple / blue class paste, duplicated across three switch
 * statements (`document-list`, and twice in `add-attachment-dialog` for the
 * object and legacy-string `fileType` shapes). With the colour gone every
 * branch rendered an identical chip, so only the label varies — and it lives
 * here once.
 */
export const FILE_TYPE_BADGE_LABEL: Record<string, string> = {
  'death-certificate': 'Death Certificate',
  will: 'Will',
  'grant-of-probate': 'Grant of Probate'
};
